import types from './types'

export default {
  [types.SET_AFFECTED_PERMISSION](state, affectedPermissionData) {
    state.affectedPermissionData = affectedPermissionData;
  },
}
